/**
 * @file
 * Applies Clamp.js to text with .line-clamp class.
 */
(function ($, Drupal) {

  'use strict';

  Drupal.applyLineClamp = function() {
    $('.line-clamp, .line-clamp-child').each(function(index, element) {
      var lines = parseInt($(element).attr('data-lines'));
      if ($(element).attr('data-child')) {
        element = $(element).find($(element).attr('data-child')).get(0);
      }
      if (typeof element !== 'undefined') {
        $clamp(element, { clamp: lines, useNativeClamp: false });
      }
    });
  }

  Drupal.behaviors.kinaxisLineClamp = {
    attach: function(context, settings) {
      Drupal.applyLineClamp();
    }
  }

})(jQuery, Drupal);